<template>
  <div class="dashboard-container">
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>

    <div class="mb-2 page-title">
      <i class="bi bi-images"></i> Slider List
    </div>

    <div class="mb-2 d-flex justify-content-between align-items-center gap-2 flex-wrap">
      <!-- Search Bar (optional) -->
      <div class="d-flex align-items-center gap-2">
        
      </div>

      <!-- Create Button -->
      <router-link to="/admin/slider-builder/create" class="button button-primary">
        <i class="bi bi-plus-square"></i> Add New
      </router-link>
    </div>

    <table class="table mt-4 align-middle">
      <thead>
        <tr>
          <th style="width: 70px;">No</th>
          <th style="width: 120px;">Image</th>
         
          <th style="width: 90px;">Sort</th>
          <th style="width: 160px;">Actions</th>
        </tr>
      </thead>

      <tbody v-if="sliders.length > 0">
        <tr v-for="(slider, index) in sliders" :key="slider.id">
          <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>

          <td>
            <div class="thumb-wrap">
              <img
                :src="getImageUrl(slider)"
                class="thumb"
                alt="slider image"
                @error="onImgError"
              />
            </div>
          </td>

          

          <td>
            <span class="badge bg-secondary">{{ slider.sort ?? 0 }}</span>
          </td>

          <td class="action-column">
            <div class="btn-group" role="group">
              <button
                type="button"
                class="button button-primary"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-card-checklist"></i> Action
              </button>

              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="editSlider(slider.id)">
                    <i class="bi bi-pencil-square"></i> Edit
                  </a>
                </li>
                <li>
                  <a class="dropdown-item text-danger" href="#" @click.prevent="deleteSlider(slider.id)">
                    <i class="bi bi-trash"></i> Delete
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody v-else>
        <tr>
          <td colspan="6" class="text-center">No sliders found.</td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <nav v-if="totalPages > 1">
      <ul class="pagination pagination-lg justify-content-end">
        <li class="page-item" :class="{ disabled: !prevPageUrl }">
          <button
            class="page-link"
            @click="changePage(currentPage - 1)"
            :disabled="!prevPageUrl"
          >
            <i class="bi bi-arrow-left-square"></i>
          </button>
        </li>

        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: currentPage === page }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>

        <li class="page-item" :class="{ disabled: !nextPageUrl }">
          <button
            class="page-link"
            @click="changePage(currentPage + 1)"
            :disabled="!nextPageUrl"
          >
            <i class="bi bi-arrow-right-square"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/config/api";

axios.defaults.baseURL = API.API_BASE_URL;

export default {
  name: "SliderList",
  data() {
    return {
      sliders: [],
      searchQuery: "",
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      prevPageUrl: null,
      nextPageUrl: null,
      loading: false,
      progress: 0,
    };
  },
  mounted() {
    this.loadSliders();
  },
  methods: {
    async loadSliders(page = 1) {
      this.loading = true;

      try {
        const response = await axios.get("/sliders", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          params: {
            page,
            per_page: this.perPage, // Laravel paginate default: per_page (kalo lu pakai perPage juga bisa, sesuaikan API lu)
            search: this.searchQuery.trim(), // kalau backend belum support, aman aja
          },
        });

        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.sliders = data;
        this.currentPage = current_page;
        this.totalPages = last_page;
        this.nextPageUrl = next_page_url;
        this.prevPageUrl = prev_page_url;

        this.loading = false;
      } catch (error) {
        console.error("Error loading sliders:", error);
        this.loading = false;
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadSliders(page);
      }
    },

    searchSliders() {
      this.currentPage = 1;
      this.loadSliders(1);
    },

    // image_url dari API (kalo ada), fallback ke /storage/{image}
    getImageUrl(slider) {
      if (slider.image_url) return slider.image_url;
      if (!slider.image) return "";

      // baseURL lu kemungkinan: http://domain.tld/api
      // public url harus: http://domain.tld
      const apiBase = (API.API_BASE_URL || "").replace(/\/$/, "");
      const publicBase = apiBase.replace(/\/api$/i, ""); // ✅ buang /api kalau ada

      return `${publicBase}/storage/${String(slider.image).replace(/^\/+/, "")}`;
    },


    onImgError(e) {
      e.target.src =
        "data:image/svg+xml;charset=utf-8," +
        encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="120" height="80">
          <rect width="100%" height="100%" fill="#eee"/>
          <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#999" font-size="12">
            no image
          </text>
        </svg>`);
    },

    editSlider(id) {
      // samain sama router lu
      // contoh: { name: "SliderEdit", params: { id } }
      this.$router.push({ path: `/admin/slider-builder/${id}/edit` });
    },

    async deleteSlider(id) {
      const ok = confirm("Yakin mau delete slider ini?");
      if (!ok) return;

      try {
        await axios.delete(`/sliders/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });

        // reload current page
        this.loadSliders(this.currentPage);
      } catch (error) {
        console.error("Failed to delete slider:", error);
        alert("Gagal delete slider.");
      }
    },
  },
};
</script>

<style scoped>
.dashboard-container {
  background-color: #ffffff;
  margin-top: 80px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.table th,
.table td {
  padding: 10px;
}

.form-control {
  width: 260px;
}

.thumb-wrap {
  width: 110px;
  height: 70px;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.link-truncate {
  max-width: 360px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background-color: #388E3C;
  animation: loader-animation 1.5s infinite;
}

@keyframes loader-animation {
  0% { width: 0; }
  50% { width: 50%; }
  100% { width: 100%; }
}
</style>
